import dateUtils from 'shared/src/date'

export const TODAY = dateUtils.dateToString(new Date())

export const processDate = (calendarConfig, date) => {
  let ret = date
  if(date == 'today') {
    ret = TODAY
  }
  if(!calendarConfig) return ret
  const min = calendarConfig.min
  const max = calendarConfig.max
  if(min && dateUtils.isBeforeOrSame(min, ret)) {
    ret = dateUtils.dateToString(dateUtils.getDate(min))
  }
  if(max && dateUtils.isAfterOrSame(max, ret)) {
    ret = dateUtils.dateToString(dateUtils.getDate(max))
  }
  return ret
}
